{
    "name": "light",
    "primary": "#93c5fd",
    "secondary": "#c4b5fd",
    "success": "#4ade80",
    "error": "#f87171",
    "warning": "#fbbf24",
    "text": "#e5e7eb",
    "textDim": "#6b7280",
    "textMuted": "#9ca3af",
    "secondaryText": "#999999",
    "border": "#374151",
    "background": "",
    "accent": "#a5b4fc",
    "toolName": "#93c5fd",
    "toolSuccess": "#4ade80",
    "toolError": "#f87171",
    "diffAdded": "#4ade80",
    "diffRemoved": "#f87171",
    "diffContext": "#6b7280",
    "diffAddedDimmed": "#69db7c",
    "diffRemovedDimmed": "#ffa8b4",
    "diffAddedWord": "#86efac",
    "diffRemovedWord": "#fca5a5",
    "diffAddedWordDimmed": "#6ee7b7",
    "diffRemovedWordDimmed": "#fda4af",
    "diffAddedBackground": "#bbf7d0",
    "diffAddedBackgroundText": "#14532d",
    "diffAddedBackgroundWord": "#15803d",
    "diffRemovedBackground": "#fecaca",
    "diffRemovedBackgroundText": "#7f1d1d",
    "diffRemovedBackgroundWord": "#b91c1c",
    "spinnerColor": "#93c5fd",
    "claude": "#fb923c",
    "claudeShimmer": "#fdba74",
    "permission": "#a5b4fc",
    "permissionShimmer": "#c7d2fe",
    "inputPrompt": "#93c5fd",
    "footerText": "#6b7280",
    "commandColor": "#a5b4fc",
    "planPrimary": "#fbbf24",
    "planBorder": "#f59e0b",
    "subtle": "#4b5563",
    "link": "#93c5fd",
    "code": "#fbbf24",
    "subagent1": "#f87171",
    "subagent2": "#93c5fd",
    "subagent3": "#4ade80",
    "subagent4": "#fbbf24",
    "subagent5": "#c4b5fd",
    "subagent6": "#fb923c",
    "subagent7": "#f472b6",
    "subagent8": "#22d3ee",
    "language": "#0d9488"
}
